import type { IContentItemsContainer } from '@kontent-ai/delivery-sdk'
import type { ScriptTagModel, SiteConfigurationModel } from '~~/app/models'
import type { FooterNavigationItems } from '~~/app/types/FooterNavigationItems'
import type { NavigationItem } from '~~/app/types/shared/NavigationItem'

interface SiteState {
  siteConfig: SiteConfigurationModel
  fetched: boolean
  linkedItems: IContentItemsContainer
  collection: string
  headerNavigationItems: NavigationItem[]
  footerNavigationItems: FooterNavigationItems
}

export const useSiteStore = defineStore('site', {
  state: (): SiteState => ({
    siteConfig: {} as SiteConfigurationModel,
    fetched: false,
    linkedItems: {} as IContentItemsContainer,
    collection: 'default',
    headerNavigationItems: [],
    footerNavigationItems: {} as FooterNavigationItems
  }),

  actions: {
    async fetchData() {
      if (!this.fetched) {
        const siteResponse = await $fetch('/api/site-configuration')
        const headerNavItemsResponse = await $fetch('/api/navigation/header-menu')
        const footerNavItemsResponse = await $fetch('/api/navigation/footer-menu')

        if (siteResponse.data) {
          this.siteConfig = siteResponse.data.item as SiteConfigurationModel

          this.linkedItems = siteResponse.data.linkedItems as IContentItemsContainer
        }

        if (headerNavItemsResponse.data) {
          this.headerNavigationItems = headerNavItemsResponse.data
        }

        if (footerNavItemsResponse.data) {
          this.footerNavigationItems = footerNavItemsResponse.data
        }

        this.fetched = true
      }
    },
    async refreshSiteData() {
      await this.fetchData()
    }
  },

  getters: {
    scriptTags: (state) => {
      const tags: ScriptTagModel[] = []

      if (state.fetched && state.siteConfig.elements?.script_tags?.value) {
        for (const item of state.siteConfig.elements.script_tags.value) {
          const linkedItem = state.linkedItems?.[item] as ScriptTagModel
          if (!linkedItem) continue
          tags.push(linkedItem)
        }
      }

      return tags
    },
    getLinkedItem:
      (state) =>
      <T>(codename: string) => {
        return state.linkedItems?.[codename] as T
      },
    getListAs:
      (state) =>
      <T>(codenames: string[]) => {
        if (codenames && codenames.length > 0) {
          return codenames.map((codename) => state.linkedItems?.[codename] as T)
        }
        return []
      }
  }
})
